import React, { useContext } from "react";
import api from "axios_interceptor/interceptor";
import {
  Box,
  Card,
  Inset,
  AspectRatio,
  Flex,
  IconButton,
  Text,
  Link,
  DropdownMenu,
  Button,
} from "@radix-ui/themes";
import { CurrentlyPlayingContext } from "context/CurrentlyPlayingContext";
import { YourGeneratedPodcastContext } from "context/LibraryYourGeneratedPodcastContext";

const MobileCoverCard = ({
  focusable,
  title,
  caption,
  cover,
  color,
  audioFileUrl,
  id,
}) => {
  const { setCurrentlyPlaying, currentlyPlaying } = useContext(
    CurrentlyPlayingContext
  );

  const handlePlayAudio = async () => {
    try {
      const response = await api.get(`/utils/audio-file/${audioFileUrl}`);

      // Handle the response, e.g., play the audio
      setCurrentlyPlaying({
        title: title,
        artist: caption,
        cover: cover,
        url: `${process.env.REACT_APP_BE_URL}/utils/audio-file/${audioFileUrl}`,
      });
    } catch (error) {
      console.error("Error fetching audio:", error);
    }
  };

  return (
    <Box p="3" m="-3">
      <Flex direction="row" align="center" gap="3" style={{ width: "100%" }}>
        {/* Image */}
        <Card
          style={{
            width: "80px",
            height: "80px",
            boxShadow: `0 8px 48px -16px ${color.replace("%)", "%, 0.6)")}`,
            overflow: "hidden",
            flexShrink: 0,
          }}
        >
          <AspectRatio ratio={1}>
            <img
              src={cover}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              alt="coverCard"
            />
          </AspectRatio>
        </Card>

        {/* Title and Caption */}
        <Flex direction="column" justify="center" style={{ flexGrow: 1 }}>
          <Link
            href="#"
            onClick={(e) => e.preventDefault()}
            tabIndex={focusable ? undefined : -1}
            size="2"
            weight="medium"
            color="gray"
            highContrast
            style={{ textDecoration: "none" }}
          >
            {title}
          </Link>
        </Flex>

        {/* Play Button */}
        <IconButton
          tabIndex={-1}
          radius="full"
          size="3"
          onClick={handlePlayAudio}
          style={{ cursor: "pointer" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="currentcolor"
            viewBox="0 0 30 30"
            width="20"
            height="20"
            style={{ marginRight: -2 }}
          >
            <path d="M 6 3 A 1 1 0 0 0 5 4 A 1 1 0 0 0 5 4.0039062 L 5 15 L 5 25.996094 A 1 1 0 0 0 5 26 A 1 1 0 0 0 6 27 A 1 1 0 0 0 6.5800781 26.8125 L 6.5820312 26.814453 L 26.416016 15.908203 A 1 1 0 0 0 27 15 A 1 1 0 0 0 26.388672 14.078125 L 6.5820312 3.1855469 L 6.5800781 3.1855469 A 1 1 0 0 0 6 3 z" />
          </svg>
        </IconButton>
      </Flex>
    </Box>
  );
};

export default MobileCoverCard;
